import colors from "assets/styles/color";
import { fontWeight } from "assets/styles/fonts";
import { showSnackBar } from "features/snackbar/snackbarSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { getNotionTermsDetail } from "services/apis";
import { signOut } from "services/authService";
import styled from "styled-components";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const handleClickLogout = () => {
    signOut();
    window.vreviewWidget.logout();
    navigate(routes.home);
    dispatch(showSnackBar({ message: "로그아웃 되었습니다." }));
  };

  const handleClickTerms = (type, title) => {
    getNotionTermsDetail(type)
      .then(({ data }) => {
        navigate(routes.commonHtmlViewer, { state: { title, content: data } });
      })
      .catch(() => {
        dispatch(showSnackBar({ message: "약관을 불러오지 못했습니다." }));
      });
  };
  return (
    <div className="footer-container">
      <div className="company-name">㈜한국금거래소</div>
      <div className="description">
        서울특별시 종로구 돈화문로5가길 1 <br />
        (돈의동, 피카디리플러스) 8층 (03139)
        <br />
        사업자등록번호: 101-86-11518 <br />
        통신판매업신고: 제01-1999호
        <br />
        대표이사: 김윤모, 개인정보책임자: 백명기
      </div>
      <div className="terms-section">
        <div>
          <span
            className="terms-left pointer"
            onClick={() =>
              handleClickTerms("PRIVACY_POLICY", "개인정보 처리방침")
            }
          >
            개인정보 처리방침
          </span>
          <span
            className="terms-right pointer"
            onClick={() =>
              handleClickTerms("SERVICE_POLICY", "서비스 이용약관")
            }
          >
            서비스 이용약관
          </span>
        </div>
        {auth.isSigned && (
          <div className="logout-section pointer" onClick={handleClickLogout}>
            로그아웃
          </div>
        )}
      </div>
      <div className="copyright">© KOREA DA Corp.</div>
    </div>
  );
};

// const FooterContainer = styled.div`
//   padding: 32px 16px 103px 16px;
//   background: ${colors.white300};
// `;

const CompanyName = styled.div`
  color: ${colors.black400};
  font-size: 14px;
  font-weight: ${fontWeight.medium};
  line-height: 20px;
  letter-spacing: -0.28px;
  margin-bottom: 8px;
`;
const Description = styled.div`
  font-size: 12px;
  font-weight: ${fontWeight.regular};
  line-height: 21px;
  letter-spacing: -0.24px;
  color: ${colors.black700};
`;

const TermsSection = styled.div`
  margin-top: 16px;
  ${({ theme }) => theme.flexBox("row", "space-between", "center")}
`;

const TermsLeft = styled.span`
  font-weight: ${fontWeight.bold};
  font-size: 12px;
  letter-spacing: -0.24px;
  color: ${colors.black200};
  text-decoration: underline;
`;
const TermsRight = styled.span`
  margin-left: 24px;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.24px;
  color: ${colors.black200};
  text-decoration: underline;
`;

const LogoutSection = styled.span`
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.24px;
  color: ${colors.black200};
`;

const Copyright = styled.div`
  font-weight: ${fontWeight.bold};
  font-size: 10px;
  letter-spacing: -0.2px;
  color: ${colors.black800};
  margin-top: 19.6px;
`;

const TossImg = styled.img`
  margin-top: 21px;
  width: 197.6px;
  height: 16px;
`;

const SeeEntryBtn = styled.button`
  color: ${colors.black700};
  font-size: 11px;
  line-height: 21px;
  letter-spacing: -0.22px;
  width: 120px;
  height: 24px;
  border: 1px solid #e0e0e0;
  ${({ theme }) => theme.flexCenter}
  margin-top: 10px;
  margin-bottom: 64px;

  img {
    width: 18px;
    height: 18px;
    margin-left: -2px;
  }
`;

export default React.memo(Footer);
